import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';
import { PermissionService } from '../../../core/services/permission.service';
import { NAV_ITEMS } from '../nav-items';
import { LogoMarkComponent } from '../../ui/logo-mark/logo-mark.component';

// Reemplaza `renderNav()` de _nav.js. Se usa dos veces: fija en desktop (AppShellComponent) y
// dentro de MobileDrawerComponent en mobile — por eso el botón de cerrar es opcional
// (`closable`), solo tiene sentido dentro del drawer.
@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, LogoMarkComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './sidebar.component.html',
})
export class SidebarComponent {
  private readonly authService = inject(AuthService);
  private readonly permissionService = inject(PermissionService);
  private readonly router = inject(Router);

  readonly closable = input(false);
  readonly closeRequested = output<void>();

  // isAccountOwner bypasea todos los permisos (CLAUDE.md §4) — filtra antes de pintar el nav
  // para no listar secciones a las que el usuario no puede entrar.
  readonly navItems = computed(() =>
    NAV_ITEMS.filter((item) => !item.permission || this.permissionService.hasPermission(item.permission)),
  );

  logout(): void {
    this.authService.logout();
    this.router.navigateByUrl('/auth/login');
  }
}
